import { Button, Col, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { FormProvider } from "react-hook-form";
import { AdminMenuLayout, ModalStore } from "../../../shared/components";
import { selectModalStore } from "../../../redux";
import { useStores } from "../hook";
import { WrapperCardStores } from "./styled";
import { TableStores } from "./TableStores";

export const Stores = () => {
  const modalStore = useSelector(selectModalStore);
  const {
    isUpdateStore,
    formMethodsCreate,
    formMethodsUpdate,
    changeModalStoresState,
  } = useStores();
  return (
    <AdminMenuLayout pageDescription="Stores" title="Stores">
      <WrapperCardStores>
        <Row
          gutter={[8, 8]}
          style={{
            padding: "10px",
            width: "100%",
          }}
        >
          <Col
            span={24}
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              type="primary"
              shape="round"
              icon={<PlusOutlined />}
              size="large"
              onClick={changeModalStoresState}
            >
              Agregar nueva tienda
            </Button>
          </Col>
        </Row>
        <TableStores />
        {modalStore && isUpdateStore && (
          <FormProvider {...formMethodsUpdate}>
            <ModalStore />
          </FormProvider>
        )}
        {modalStore && !isUpdateStore && (
          <FormProvider {...formMethodsCreate}>
            <ModalStore />
          </FormProvider>
        )}
      </WrapperCardStores>
    </AdminMenuLayout>
  );
};
